<template>
  <v-row align="center" justify="center">
    <v-col cols="10">
      <v-progress-linear v-if="$apollo.loading" indeterminate />
      <highcharts v-if="recipieViewsPerDate" :options="recipieViewsPerDateReport"></highcharts>
    </v-col>
  </v-row>
</template>

<script>
import { RECIPIE_VIEWS_PER_DAY_QUERY } from "@/graphql/queries/engagement.js";

export default {
  name: "recipieViewsPerDate",
  props: {
    startDate: {
      type: String,
    },
    endDate: {
      type: String,
    },
    uniqueUsers: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Recipe views per day",
    },
  },
  data() {
    return {
      recipieViewsPerDate: null,
    };
  },
  computed: {
    recipieViewsPerDateReport() {
      return {
        chart: {
          type: "line",
        },
        legend: {
          layout: "vertical",
          align: "right",
          verticalAlign: "middle",
        },
        plotOptions: {
          series: {
            label: {
              connectorAllowed: false,
            },
          },
        },
        title: {
          text: this.title,
        },
        xAxis: {
          categories: this.recipieViewsPerDate.dateSeries.map((c) => c["actionDate"]),
        },
        yAxis: {
          title: {
            text: "# of users",
          },
        },
        credits: {
          enabled: false,
        },
        series: [
          {
            name: "View Count",
            data: this.recipieViewsPerDate.dateSeries.map((c) => [c["actionDate"], parseInt(c["userCount"])]),
          },
        ],
      };
    },
  },
  apollo: {
    recipieViewsPerDate: {
      query: RECIPIE_VIEWS_PER_DAY_QUERY,
      variables() {
        return {
          uniqueUsers: this.uniqueUsers,
          startDate: this.startDate,
          endDate: this.endDate,
        };
      },
    },
  },
};
</script>
